import { useMsal } from "@azure/msal-react";
import {
	createContext,
	ReactElement,
	useContext,
	useMemo,
	useState,
} from "react";
import { catchError, delay, EMPTY, from, map, Observable, of, switchMap } from "rxjs";
import { login } from "../api";
import { loginRequest } from "../api/authConfig";
import { isNil } from 'lodash';

interface AuthProviderProps {
	children?: ReactElement;
}

interface AuthContextInterface {
	accessToken?: string;
	acquireToken(): Observable<string>;
	error?: any;
	handleLogin: (username: string, password: string) => Observable<boolean>;
	isAuthenticated: boolean;
	loading: boolean;
	logout(): Observable<void>;
	username?: string;
	validateUser(errorCallback: () => void): void;
}

const AuthContext = createContext<AuthContextInterface>(
	{} as AuthContextInterface
);

export function AuthProvider({ children }: AuthProviderProps) {
	const [accessToken, setAccessToken] = useState<string>();
	const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
	const [error, setError] = useState<any>();
	const [loading, setLoading] = useState<boolean>(false);

	const { accounts, instance } = useMsal();

	function handleLogin(
		username: string,
		password: string
	): Observable<boolean> {
		setLoading(true);
		return login(username, password).pipe(
			catchError((error) => {
				setLoading(false);
				setError(error.message);
				return EMPTY;
			}),
			map(() => {
				setAccessToken(accessToken);
				setIsAuthenticated(true);
				setLoading(false);
				return true;
			})
		);
	}

	function acquireToken(): Observable<string> {
		// return fake token 
		return of('fake-jwt-token-12345').pipe(
			// simulate network delay
		);
		// return from(
		// 	instance.acquireTokenSilent({
		// 		account: accounts[0],
		// 		...loginRequest,
		// 	})
		// ).pipe(
		// 	catchError(() => {
		// 		return from(instance.loginRedirect(loginRequest)).pipe(
		// 			switchMap(() =>
		// 				from(
		// 					instance.acquireTokenSilent({
		// 						account: accounts[0],
		// 						...loginRequest,
		// 					})
		// 				)
		// 			)
		// 		);
		// 	}),
		// 	map((response) => response.accessToken)
		// );
	}

	function logout(): Observable<void> {
		return from(instance.logoutRedirect());
	}

	function getUser() {
		return "admin@crayon.com"
		// return instance.getActiveAccount()?.username;
	}

	function validateUser(errorCallback: () => void) {
		const errorMessage = 'Could not retrieve user from local storage';
		const username = getUser();
		if (isNil(username)) {
			const user = localStorage.getItem('user');
			try {
				const parsedUser = user ? JSON.parse(user).user : null;
				if (isNil(parsedUser)) {
					console.log(errorMessage);
					errorCallback();
				}
			} catch (error) {
				console.error(errorMessage, error);
				errorCallback();
			}
		}
	}

	const memo = useMemo(
		() => ({
			accessToken,
			acquireToken,
			error,
			handleLogin,
			isAuthenticated,
			loading,
			logout,
			username: getUser(),
			validateUser,
		}),
		[accessToken, error, instance, isAuthenticated, loading, accounts]
	);

	return <AuthContext.Provider value={memo}>{children}</AuthContext.Provider>;
}

function useAuth() {
	return useContext(AuthContext);
}

export default useAuth;
